<script lang="ts">var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { Readable } from "svelte/store";
import { getFirstSourceStore, getTemplatedElementDataFromSource, } from "../../../utilities";
import { t } from "../../../../../js/i18n";
export let element;
export let sources;
$: source = getFirstSourceStore($sources);
$: console.log('Loyalty.ProfileHeader data', $source);
let sourceRefreshed = false;
$: if (source && $source && !sourceRefreshed) {
    setTimeout(() => {
        $sources[0].refresh();
    }, 0);
    sourceRefreshed = true;
}
$: fontFaceName = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.fontFaceName) || "";
$: fontFaceDetail = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.fontFaceDetail) || "";
$: textColor = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.textColor) || "";
$: fontSizeName = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.fontSizeName) || "";
$: fontSizeDetail = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.fontSizeDetail) || "";
$: progressForegroundColor = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.progressForegroundColor) || "";
$: progressBackgroundColor = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.progressBackgroundColor) || "";
$: progressMaxPoints = Number(((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.progressMaxPoints) || 1);
$: profileSegment = ((_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.profileSegment) || "USER";
$: name = getNameFromProfile(profileSegment, $source === null || $source === void 0 ? void 0 : $source.Profile) || ((_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.name) || "Welcome!";
$: value = ($source === null || $source === void 0 ? void 0 : $source.PointTotal) || Number(((_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.value) || 0);
function getNameFromProfile(profileSegment, profile) {
    if (!profile) {
        return null;
    }
    let firstName = '', lastName = '';
    for (let rec of profile) {
        if ((rec === null || rec === void 0 ? void 0 : rec.Segment) === profileSegment && rec.Value && rec.Value !== 'null') {
            if (rec.Key === 'first_name') {
                firstName = rec.Value;
            }
            if (rec.Key === 'last_name') {
                lastName = rec.Value;
            }
        }
    }
    return `${firstName} ${lastName}`.trim();
}
</script>

<CardBase {element}>
  <div class="profile-header">
    <h4
      class="name"
      style={`font-family: ${fontFaceName}; font-size: ${fontSizeName}; color: ${textColor};`}
    >
      {name}
    </h4>
    <div
      class="description"
      style={`font-family: ${fontFaceDetail}; font-size: ${fontSizeDetail}; color: ${textColor};`}
    >
      {$t("You have")} {value} {$t("tokens")}
    </div>
    <div class="progress-bar">
      <div class="track-0" style={`background: ${progressBackgroundColor};`} />
      <div class="track-1" style={`background: ${progressForegroundColor}; width: ${value * 100.0 / progressMaxPoints}%;`} />
    </div>
  </div>
</CardBase>

<style type="text/scss">*,
*:before,
*:after {
  box-sizing: border-box;
}

.profile-header {
  display: flex;
  flex-direction: column;
}

.name {
  margin: 0;
  padding: 0;
}

.description {
  margin: 2px 0 8px 0;
}

.progress-bar {
  position: relative;
  height: 16px;
}

.track-0, .track-1 {
  border-radius: 10px;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.track-0 {
  width: 100%;
}</style>
